import {
    Row, Col, Image, Typography,
} from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import IMAGES from '../../../constants/images';

const { Title, Text } = Typography;

const Inspiration = () => {
    const { t } = useTranslation('institutional', { keyPrefix: 'INSPIRATION' });

    const items: String[] = [
        'PARAGRAPH_1',
        'PARAGRAPH_3',
        'PARAGRAPH_4',
        'PARAGRAPH_5',
        'PARAGRAPH_6',
        'PARAGRAPH_7',
        'PARAGRAPH_8',
        'PARAGRAPH_9',
        'IMAGE_DESCRIPTION',
    ];

    return (
        <div className="section__training" id="insipiration">
            <Title level={2}>
                {t('INSPIRATION')}
            </Title>
            <div className="section__training--information-line" />
            <div className="section__training--information">
                <Row className="full__width full__height">
                    <Col xs={24} xl={12} className="section__training--information-text">
                        {
                            items.map((item, index) => (
                                <Text key={index} className="section__training--information-item">
                                    <Trans
                                        t={t}
                                        i18nKey={`${item}`}
                                        components={{
                                            b: <b style={{ color: '#1E3A90' }} />,
                                            u: <u style={{ color: '#1E3A90' }} />,
                                            i: <i />,
                                        }}
                                    />
                                </Text>
                            ))
                        }
                    </Col>
                    <Col
                        xs={24}
                        xl={12}
                        className="section__training--information-container"
                    >
                        <Image
                            className="image-right"
                            preview={false}
                            src={IMAGES.illustrations.lightHouse}
                            height="100%"
                            width="100%"
                        />
                        <Text className="image-description">
                            {t('IMAGE_DESCRIPTION')}
                        </Text>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default Inspiration;
